<div class="p-24">
  <p>{{ data }}</p>
</div>
